import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(VCol,[(_vm.isVisible)?_c(VBtn,{staticStyle:{"bottom":"40px"},attrs:{"color":"primary","dark":"","bottom":"","right":"","fab":"","fixed":""},on:{"click":function($event){return _vm.create()}}},[_c(VIcon,[_vm._v(" mdi-plus ")])],1):_vm._e(),_c('WorklogDetailsDialog')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }